import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';
import { Checkbox } from 'semantic-ui-react';
import { push } from "connected-react-router";

import MessageItem from "./MessageItem/MessageItem";
import PaginationBlock from "../../ui/PaginationBlock/PaginationBlock";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";

import {
  changeMessagesPage,
  changeMessagesLimit,
  getMessagesListAsync,
  switchMessagesFilter,
  goToMessageCreation,
} from "../../../redux/actions/messagesList";

const mapStateToProps = state => ({
  ...state.messagesList,
});

const mapDispatchToProps = dispatch => ({
  onChangePage: page => dispatch(changeMessagesPage(page)),
  onChangeDisplayOption: limit => dispatch(changeMessagesLimit(limit)),
  onCreateMessage: () => dispatch(goToMessageCreation()),
  getMessagesList: payload => dispatch(getMessagesListAsync(payload)),
  switchFilter: filter => dispatch(switchMessagesFilter(filter)),
  onClickMessageItem: msgId => dispatch(push(`/message/${msgId}`)),
});

class MessagesList extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    messages: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    activePage: PropTypes.number.isRequired,
    filters: PropTypes.object.isRequired,
    onChangePage: PropTypes.func.isRequired,
    onChangeDisplayOption: PropTypes.func.isRequired,
    onCreateMessage: PropTypes.func.isRequired,
    getMessagesList: PropTypes.func.isRequired,
    switchFilter: PropTypes.func.isRequired,
    onClickMessageItem: PropTypes.func.isRequired,
  };

  componentDidMount = () => { 
    const { getMessagesList } = this.props;
    const payload = this.setPayload();
    getMessagesList(payload);
  }

  //Пагинация и фильтры
  componentDidUpdate = previousProps => {
    const { limit, activePage, filters, getMessagesList } = this.props;
    const payload = this.setPayload();

    //Условия перезагрузки
    if (
      (previousProps.activePage !== activePage)
      || (previousProps.limit !== limit)
      || (previousProps.filters.client !== filters.client)
      || (previousProps.filters.consultant !== filters.consultant)
      || (previousProps.filters.any !== filters.any)
    ) getMessagesList(payload);
  }

  setPayload = () => {
    const { limit, activePage, filters } = this.props;
    //Пагинация:
    //limit - количество пользователей на одну страницу пагинации
    //page - активная страница
    
    //role - роль пользователя, по которой происходит фильтрация
    const payload = {
      limit,
      page: activePage,
      role: [],
    };

    //Фильтры
    if (filters.client) payload.role.push('client');
    if (filters.consultant) payload.role.push('consultant');
    if (filters.any) payload.role.push('any');
    return payload;
  }

  renderMessagesList = (message, i) => {
    const { onClickMessageItem } = this.props;
    return(
      <MessageItem
        key={`${message.id}_${i}`}
        message={message}
        onClickMessage={(id) => onClickMessageItem(id)}
      />
    );
  }

  render() {
    const {
      ready, loading, messages, limit, total, activePage, filters, onChangePage, onChangeDisplayOption, onCreateMessage,
      switchFilter,
    } = this.props;

    //Рассчитаем количество страниц пагинации
    const pagesCount = Math.ceil(total / limit);

    const contentClass = classnames({
      'list-items-content': true,
      'hollow': messages.length === 0,
    });

    return (
      <div className="list-items-wrap">
        <div className="list-items-header"> 
          <button type="button" className="btn btn-green messages" onClick={() => onCreateMessage()}>Создать сообщение</button>
          <div className="filters-wrap">
            <Checkbox
              label='Для клиентов'
              checked={filters.client}
              onChange={() => switchFilter('client')} 
            />
            <Checkbox
              label='Для консультантов'
              checked={filters.consultant}
              onChange={() => switchFilter('consultant')}
            />
            <Checkbox
              label='Для всех'
              checked={filters.any}
              onChange={() => switchFilter('any')}
            />
          </div>
        </div>
        {ready ? (
          <React.Fragment>
            <div className={contentClass}>
              {messages.length !== 0 ? 
                messages.map(this.renderMessagesList)
              : (
                <div className="hollow-text">
                  Здесь пока пусто.<br />
                  Создайте первое сообщение
                </div>
              )}
            </div>
            {messages.length !== 0 ? (
              <div className="list-items-footer">
                <PaginationBlock
                  activePage={activePage}
                  pagesCount={pagesCount}
                  pagesVisible={7}
                  onChangePage={onChangePage}
                  displayOptions={[15, 30, 60, 120]}
                  selectedDisplayOption={limit}
                  selectDisplayOption={onChangeDisplayOption}
                />
              </div>
            ) : false}
          </React.Fragment>
        ) : false}
        {loading ? (<Spinner />) : false}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(MessagesList));
